import React, { useContext, useEffect, useState } from 'react';
import { MDBCard, MDBListGroup, MDBListGroupItem, MDBCardHeader, MDBIcon } from 'mdb-react-ui-kit';
import { IdeaBoxEntry, TaskType } from 'konect-model';
import { GlyphEvent, GlyphEventService } from '../../services/event-service';
import AcceptModal from './AcceptModal';
import "./InformationCard.css";
import DropdownSelect from './DropdownSelect';
import { AppContext, NavState } from '../App';
import UserControlService from '../../services/user-control-service';
import { getAttributeLabel } from './IdeaBoxRow';
import { nanoid } from 'nanoid';

interface InformationCardProps {
    entry: IdeaBoxEntry;
    dim?: boolean;
    onCopy?: () => void;
}

const CARD_STYLE = { margin: "0 auto", textAlign: "center", maxWidth: "250px", minWidth: "200px", transition: "filter 0.2s ease" }

const InformationCard = (props: InformationCardProps) => {
    const { project, setProject, navState, setEditingTask } = useContext(AppContext);
    const [showLink, setShowLink] = useState(NavState.GLYPH_SKETCH === navState && props.entry.linkedCells.length > 0);
    const [collapse, setCollapse] = useState(showLink);
    const entry = props.entry;

    useEffect(() => {
        setShowLink(NavState.GLYPH_SKETCH === navState && props.entry.linkedCells.length > 0);
        setCollapse(NavState.GLYPH_SKETCH === navState && props.entry.linkedCells.length > 0)
        setShowLink(NavState.GLYPH_SKETCH === navState && props.entry.linkedCells.length > 0);
        setCollapse(NavState.GLYPH_SKETCH === navState && props.entry.linkedCells.length > 0)
    }, [navState, props.entry.linkedCells])

    const removeLink = () => {
        GlyphEventService.dispatch(GlyphEvent.REMOVE_LINKS, props.entry);
        setShowLink(false);
        setCollapse(false);
        setCollapse(false);
    }

    const handleDropdownClick = (event: any) => {
        UserControlService.update();
        switch (event.target.name) {
            case "insight":
                const insight = JSON.parse(event.target.dataset["mssg"]);
                entry.insight = insight;
                entry.visualLevel = insight.visualLevel;
                entry.availableAttributes = project.getAttributesOfInsight(insight);
                entry.selectedAttribute = entry.availableAttributes[0];
                break;
            case "selectedAttribute":
                const attribute = JSON.parse(event.target.dataset["mssg"]);
                entry.selectedAttribute = attribute;
                break;
            default:
                //@ts-ignore
                entry[event.target.name] = event.target.value;
        }
        project.ideaBox.updateEntry(entry.id, { ...entry });
        setProject(project);
    }

    const editEntry = () => {
        UserControlService.changeView(NavState.TASK_EDITOR);
        const task = project.taskModel.rootTask.findTask(entry.task.id);
        if (!task) return;
        setEditingTask(task);
    }

    const duplicateEntry = () => {
        UserControlService.update();
        const task = project.taskModel.rootTask.findTask(entry.task.id);
        if (!task) return;
        console.log(project.ideaBox.entries.indexOf(entry))
        const { newIdeaBoxEntries } = task.addTaskRule(project, nanoid(), entry.interfaceElement, [entry.type], project.ideaBox.entries.indexOf(entry));
        for (const glyph of project.glyphs) {
            let layer = glyph.findLayerOfTask(entry);
            if (layer) {
                layer.entries.push(newIdeaBoxEntries[0]);
                break;
            }
        }
        setProject(project);
    }


    return (
        <MDBCard onClick={(e : any) => {e.target && e.target.type !== "button" && showLink && setCollapse(!collapse)}} style={{...CARD_STYLE, ...(props.dim ? {filter : "brightness(0.8)"} : {})}}>
            <MDBCardHeader background={props.entry.type === TaskType.INTERACTION ? 'primary' : "warning"} style={{paddingLeft: "35px", paddingRight: "35px"}}>
                <p style={{ opacity: "0.9", lineHeight: "125%", marginBottom: "5px" }}> {props.entry.task.name}</p>
                {showLink && props.entry.linkedCells.length > 0 && <AcceptModal style={{ position: "absolute", right: "0.5rem", top: "0.5rem" }} onAccept={removeLink} imgType='unlink' />}
                <h6 style={{ margin: "0px" }}>{props.entry.interfaceElement}</h6>
            </MDBCardHeader>
            {navState !== NavState.GLYPH_SKETCH &&
            <div className="options">
                <div className="d-flex flex-column gap-1">
                    <span className={"accept-modal-button option edit-option "} onClick={editEntry}>
                        <MDBIcon fas icon='pen' />
                    </span>
                    <span className={"accept-modal-button option duplicate-option "} onClick={duplicateEntry}>
                        <MDBIcon fas icon='copy' />
                    </span>
                </div>
            </div>}

            <MDBListGroup flush className={"information-hover-card-group"} style={showLink && collapse ? {maxHeight: "1rem"} : {maxHeight: "300px"}}>
                <MDBListGroupItem className={'card-dropdown-container'}>
                    {/*@ts-ignore*/}
                    <font className='text-dark'><small><small>Insight</small></small></font><br />
                    <DropdownSelect
                        type="insight"
                        value={props.entry.insight && props.entry.insight.name}
                        defaultValue={"select insight"}
                        items={project.insights.filter(el => props.entry.type === el.type)}
                        onClick={handleDropdownClick}
                    />
                    {!entry.insight && <i className={"fas fa-exclamation card-exclamation"}/>}
                </MDBListGroupItem>
                {entry.insight &&
                    <MDBListGroupItem>
                        {/*@ts-ignore*/}
                        {entry.insight && <><font className='text-dark'><small><small>Attribute</small></small></font><br /></>}
                        {
                            entry.insight && <DropdownSelect
                                type="selectedAttribute"
                                value={getAttributeLabel(entry)}
                                defaultValue={"select attribute"}
                                items={entry.availableAttributes}
                                onClick={handleDropdownClick}
                            />
                        }
                    </MDBListGroupItem>
                }
            </MDBListGroup>
        </MDBCard>
    );
};

export default InformationCard;
